import React, { useState, useEffect } from "react";
import { Card, Select, Button } from "../../../../../common";

export const AddInsuranceForm = ({
  onSearch,
  selectedCompany,
  selectedCompanyBroker,
  showForm,
  insuranceInfo,
  optionName,
  selectedInsuranceType, showOptionName,
  refetch, compRefetch, dataChanged, setDataChanged
}) => {
  const [insurer, setInsurerName] = useState(selectedCompany);
  const [option, setOption] = useState(optionName || showOptionName);
  const [broker, setBrokerName] = useState(selectedCompanyBroker);

  const handleInsurerName = (e) => {
    e.preventDefault();
    setInsurerName(e.target.value);

    if (e.target.value.length >= 3) {
      onSearch(e.target.value);
    }
  };
  const handleBrokerName = (e) => {
    e.preventDefault();
    setBrokerName(e.target.value);

    if (e.target.value.length >= 3) {
      onSearch(e.target.value);
    }
  };
  const handleOptionChange = (e) => {
    optionName(e.target.value);
    setOption(e.target.value);
  };

  const goToSearch = (type) => {
    onSearch();
    showForm(type);
  };

  return (
    <Card classes="rounded bg-white p-4 w-[34rem]">
      <h5 className="text-f18 text-secondarytwo text-left mb-4 font-bold">
        Add Insurance Information
      </h5>

      <div className="">
        <Select
          label="Type"
          id="type"
          value={showOptionName || option || selectedInsuranceType}
          placeholder="Select a Type"
          onChange={handleOptionChange}
          icon={true}
        >
          <option value="" disabled selected>Select Type</option>
          <option value="employee benefit">Employee Benefit</option>
          <option value="marine">Marine</option>
          <option value="construction">Construction</option>
          <option value="energy">Energy</option>
          <option value="speciality lines">Specialty Lines</option>
          <option value="trade credit">Trade Credit</option>
          <option value="property">Property</option>
          <option value="other general lines">Other General Lines</option>
        </Select>
        <label
          htmlFor="name"
          className="block mb-1 text-primary text-f14 font-semibold text-left"
        >
          Insurer
        </label>
        <Button
          onClick={() => goToSearch("insurer")}
          classes={`w-full text-left border focus:border-primary px-3 py-2 border-input rounded bg-inputDisable mb-4 ${selectedCompany ? "hidden" : "block"
            }`}
        >
          Search
        </Button>
        <input
          label="Company Name"
          id="name"
          value={
            insurer
              ? insurer.name ||
              insurer.registered_company_name ||
              selectedCompany
              : ""
          }
          onChange={handleInsurerName}
          className={`w-full border focus:border-primary px-3 py-2 border-input rounded bg-inputDisable mb-4 ${selectedCompany ? "block" : "hidden"
            }`}
          disabled={Boolean(insurer)}
        />
        <label
          htmlFor="name"
          className="block mb-1 text-primary text-f14 font-semibold text-left"
        >
          Broker
        </label>
        <Button
          onClick={() => goToSearch("broker")}
          classes={`w-full text-left border focus:border-primary px-3 py-2 border-input rounded bg-inputDisable mb-4 ${selectedCompanyBroker ? "hidden" : "block"
            }`}
        >
          Search
        </Button>
        <input
          label="Company Name"
          id="name"
          value={
            broker
              ? broker.name ||
              broker.registered_company_name ||
              selectedCompanyBroker
              : ""
          }
          onChange={handleBrokerName}
          className={`w-full border focus:border-primary px-3 py-2 border-input rounded bg-inputDisable mb-4 ${selectedCompanyBroker ? "block" : "hidden"
            }`}
          disabled={Boolean(broker)}
        />

        <Button
          classes={`${selectedCompany ? "bg-primary" : " bg-disable"
            } w-full p-2 text-white rounded text-f18 mt-4`}
          onClick={insuranceInfo}
        >
          Submit
        </Button>
      </div>
    </Card>
  );
};
